import { LOCALES } from 'i18n/locales';

export const workpackOmissionModalIntl = {
    [LOCALES.ENGLISH]: {
        'workpackOmissionModal.title': 'Important information',
        'workpackOmissionModal.warningBody': 'Please contact asset owners identified in your area of interest in accordance with their existing protocol to inform them of your activity.',
        'workpackOmissionModal.omittedOwnersTitle': 'Data from the following asset owners will not be displayed in the map PDF.'
    },
    [LOCALES.WELSH]: {
        'workpackOmissionModal.title': '[Important information]',
        'workpackOmissionModal.warningBody': 'Cysylltwch â pherchnogion asedau yn eich ardal diddordeb yn unol â\'r protocol presennol i\'w hysbysu o\'ch gweithgarwch.',
        'workpackOmissionModal.omittedOwnersTitle': '[Data from the following asset owners will not be displayed in the map PDF.]'
    }
};
